import { useTheme as useThemeHook } from "@emotion/react";
export function useTheme() {
  return useThemeHook();
}